<template>
  <div
    v-if="bodanList.length"
    class="bd-detail-list"
  >
    <div
      v-for="(obj, index) in bodanList"
      :key="index"
      class="bd-detail-mod"
    >
      <h2>
        <strong>{{ index + 1 }}.</strong>
        <span>{{ obj.name }}</span>
      </h2>
      <div class="bd-detail-mod-txt">
        <span v-if="getTxt(obj)">{{ getTxt(obj) }}</span>
      </div>
      <template v-if="obj.width < obj.height">
        <div class="bd-img">
          <div class="bd-top-bg">
            <img v-lazy="checkHttps(obj.picurl)">
            <div class="mask" />
          </div>
          <div class="img-box">
            <img v-lazy="checkHttps(obj.picurl)">
          </div>
        </div>
      </template>
      <template v-else>
        <div class="img-box-h">
          <img :src="obj.picurl">
        </div>
      </template>
      <div :class="{ btn: obj.wholeplay !== '' && obj.quickplay !== '' }">
        <a
          v-if="obj.quickplay !== ''"
          :href="obj.quickplay"
          :class="[{ more: obj.wholeplay === '' }, 'quick']"
          uigs="quick"
        >速看版</a>
        <a
          v-if="obj.wholeplay !== ''"
          :href="obj.wholeplay"
          :class="[{ more: obj.quickplay === '' }, 'whole']"
          uigs="whole"
        >{{ obj.trailer ? '预告片' : '完整版' }}</a>
      </div>
      <a
        v-if="obj.wholeplay === '' && obj.quickplay === ''"
        id="more"
        :href="obj.moreplay"
        class="more"
        uigs="more"
      >更多可播资源</a>
      <p class="intro">
        {{ obj.intro }}
      </p>
    </div>
    <span class="bd-detail-end">- The End -</span>
  </div>
</template>

<script>
import { checkHttpsUrl } from '../../common/js/util';

export default {
  name: 'BodanInfo',
  props: {
    bodanList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatScore(str) {
      let strRet = str;
      if (strRet && strRet.indexOf('.') === -1) {
        strRet += '.0';
      }
      return strRet;
    },
    getTxt(obj) {
      const ret = [];
      if (obj.year) {
        ret.push(`${obj.year}年上映`);
      }
      if (obj.score) {
        ret.push(`豆瓣评分：${this.formatScore(obj.score)}`);
      }
      return ret.join('，');
    },
    checkHttps(url) {
      return checkHttpsUrl(url);
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_playlist.scss';

.bd-detail-list {
  padding: 0px 14px;
}

.bd-detail-mod {
  margin-bottom: 28px;

  h2 {
    display: inline-block;
    position: relative;
    z-index: 0;
    max-width: 100%;
    font-size: 22px;
    font-weight: bold;
    color: rgba(34, 34, 34, 1);
    line-height: 34px;

    span {
      margin-left: 4px;
    }
  }

  .intro {
    font-size: 17px;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
    line-height: 29px;
  }
  a {
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    align-items: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    justify-content: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    line-height: 40px;
    font-weight: 400;
    font-size: 15px;
    color: rgba(34, 34, 34, 1);
    background: rgba(245, 245, 245, 1);
    border-radius: 3px;
  }
}

.bd-detail-mod-txt {
  margin-top: 2px;
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 15px;
}

.bd-img {
  width: 100%;
  height: 192px;
  position: relative;

  .img-box {
    width: 130px;
    height: 192px;
    margin: 0 auto;
    overflow: hidden;

    > img {
      width: 100%;
      height: 100%;
    }
  }

  .bd-top-bg {
    position: absolute;
    overflow: hidden;
    width: 100%;
    height: 192px;
    right: 0;
    top: 0;
    z-index: -1;
    border-radius: 5px;
    img {
      width: 100%;
      height: 100%;
      filter: blur(50px);
      -webkit-filter: blur(50px);
      -moz-filter: blur(50px);
      -ms-filter: blur(50px);
      //vertical-align: top;
      position: absolute;
      transform: translateZ(0);
      -ms-transform: translateZ(0);
      -moz-transform: translateZ(0);
      -webkit-transform: translateZ(0);
      -o-transform: translateZ(0);
    }

    .mask {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.3);
      z-index: 3;
      border-radius: 5px;
    }
  }
}

.img-box-h {
  width: 100%;
  height: 206px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.bd-detail-mod .btn {
  margin-top: 10px;
  margin-bottom: 14px;
  overflow: hidden;

  > a:first-of-type {
    float: left;
  }
  > a:last-of-type {
    float: right;
  }
}
.quick {
  width: 48%;
  &:before {
    content: '';
    display: inline-block;
    margin-right: 4px;
    @include sprite-item('playlist/time');
  }
}
.whole {
  width: 48%;
  &:before {
    content: '';
    margin-right: 4px;
    @include sprite-item('playlist/play');
  }
}

.bd-detail-mod a.more {
  width: 100%;
  margin: 10px auto 14px;
}

#more {
  &:after {
    content: '';
    margin-left: 4px;
    margin-bottom: 1px;
    @include sprite-item('playlist/arrow');
  }
}

.bd-detail-end {
  display: block;
  position: relative;
  font-size: 15px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 15px;
  text-align: center;
  margin-bottom: 30px;
}
</style>
